import { FC } from "react";
import { faCopy } from "@fortawesome/free-solid-svg-icons";
import OrderDetailsToolButtonComponent from "../../common/tool-button/order-details-tool-button.component";
import OrderDetailsCargoOrder from "../../common/types/order-details-cargo-order";
import OrderDetailsToolsTranslations from "../../../../../languages/types/order/details/order-details-tools.translation";

type OrderDetailsCopyComponentProps = {
  details: OrderDetailsCargoOrder | null;
  tools: OrderDetailsToolsTranslations;
  onSuccess: () => void;
};

const OrderDetailsCopyComponent: FC<OrderDetailsCopyComponentProps> = ({
  details,
  tools,
  onSuccess,
}) => {
  const { isFinished, isCancelled } = details!;

  if (!(!isFinished && !isCancelled)) return null;

  const { copyDetailsButtonTitle } = tools;

  return (
    <OrderDetailsToolButtonComponent
      onClick={onSuccess}
      icon={faCopy}
      title={copyDetailsButtonTitle}
    />
  );
};

export default OrderDetailsCopyComponent;
